export default class TimelineAccessUserData
{
    userid = ""
    username = ""
    display_name : string | null = null
    email = ""
    currentUser = false // TODO is this necessary? shouldn't we just do a userid comparison? also can we just get rid of this and replace with User?

    get uiName()
    {
        return this.display_name || this.username;
    }
}